import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue'
import baseMessage from '../components/baseMessage.vue'
import commitList from '../components/commitList.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import Editor from '@/components/Editor'
import UploadFile from '@/components/UploadFile'
import { DcMessage } from '@dc-platform/dc-components'
import { followRecordsAddComment } from '@/api/overseasSales/followUpManage'
import type { commentItem, FbuFollowUpRecordEdit } from '@/typings/api/followUpManage'
import { layoutTags } from '@dc-platform/dc-interaction'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const __default__ = {
  name: 'DcCosOFbuFollowUpRecordCommit'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  type: {
    default: String
  }
},
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const form = ref<commentItem>({
  fileId: []
})
const props = __props
const activeKey = ref('base')
const loading = ref(false)
const detail = ref({})
const commitListRef = ref()
const showComment = ref(false)
const commentComputed = computed(() => {
  if (props.type === 'comment') {
    return true
  }
  return showComment.value
})
//
const showCommentFrom = () => {
  showComment.value = true
  // setTimeout(() => {
  //   const h = document.body.clientHeight
  //   window.scrollTo({
  //     top: h
  //     // behavior: 'smooth'
  //   })
  // }, 50)
}
const handleCommit = () => {
  if (!form.value.content) {
    // const h = document.getElementById('app')?.scrollHeight
    // document.getElementById('app')?.scrollTo({
    //   top: h,
    //   behavior: 'smooth'
    // })
    DcMessage.warning(t('tips.inputComment'))
    return
  }
  loading.value = true
  // 评论必填
  followRecordsAddComment({
    followId: route.query.id,
    ...form.value
  })
    .then((res) => {
      DcMessage.success(t('tips.commentSuccess'))
      layoutTags.close()
    })
    .finally(() => {
      loading.value = false
    })
}
const getDetail = (data: FbuFollowUpRecordEdit) => {
  detail.value = data
}
const handleEdit = () => {
  router.push({
    path: '/ofbu/followUpRecord/edit',
    query: {
      id: route.query.id
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                activeKey: activeKey.value,
                "onUpdate:activeKey": _cache[3] || (_cache[3] = ($event: any) => ((activeKey).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "base",
                    tab: _unref(t)('common.baseTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(baseMessage, {
                        disabled: true,
                        view: "",
                        onGetDetail: getDetail,
                        hideOk: true
                      }),
                      _createVNode(commitList, {
                        ref_key: "commitListRef",
                        ref: commitListRef,
                        permissionPage: {
                delCommit: __props.type === 'view' ? 'ofbu_follow_view_del_commit' : 'ofbu_follow_list_del_commit'
              },
                        data: detail.value.commentList,
                        id: _unref(route).query.id
                      }, null, 8, ["permissionPage", "data", "id"]),
                      (commentComputed.value)
                        ? (_openBlock(), _createBlock(_component_a_form, {
                            key: 0,
                            name: "detailsForm",
                            ref: "formRef",
                            model: form.value
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_dc_layout_card, {
                                title: _unref(t)('follow.commentTitle')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Editor), {
                                        value: form.value.content,
                                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.content) = $event)),
                                        maxlength: 3000,
                                        mention: form.value.userCodes,
                                        "onUpdate:mention": _cache[1] || (_cache[1] = ($event: any) => ((form.value.userCodes) = $event)),
                                        placeholder: _unref(t)('common.pleaseInput')
                                      }, null, 8, ["value", "mention", "placeholder"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_dc_form_item, {
                                    label: _unref(t)('follow.UploadAttachments'),
                                    name: "fileId",
                                    span: 24
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(UploadFile), {
                                        value: form.value.fileId,
                                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.fileId) = $event)),
                                        valueType: "array"
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }, 8, ["title"])
                            ]),
                            _: 1
                          }, 8, ["model"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "operationLog",
                    tab: _unref(t)('common.operationLogTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsOperationLog, {
                        tableId: "DcCosOfbuFollowUpOperationLog",
                        appId: "cos_ofbu",
                        resourceId: _unref(route).query.id
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  }, 8, ["tab"])
                ]),
                _: 1
              }, 8, ["activeKey"])
            ]),
            _: 1
          }),
          _createVNode(_component_cos_footer_button, {
            loading: loading.value,
            hideOk: ""
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: handleCommit,
                loading: loading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.issue')), 1)
                ]),
                _: 1
              }, 8, ["loading"])), [
                [_vShow, commentComputed.value && activeKey.value === 'base'],
                [_directive_permission, 'ofbu_follow_comment_btn']
              ]),
              (__props.type === 'view')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      onClick: showCommentFrom,
                      loading: loading.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('btn.comment')), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])), [
                      [_vShow, !commentComputed.value && activeKey.value === 'base'],
                      [_directive_permission, 'ofbu_follow_comment_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                      type: "primary",
                      workCode: detail.value.dutyBy,
                      controlType: "none",
                      onClick: handleEdit,
                      loading: loading.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                      ]),
                      _: 1
                    }, 8, ["workCode", "loading"])), [
                      [_directive_permission, 'ofbu_follow_edit_btn']
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})